import { render, staticRenderFns } from "./afterSale.vue?vue&type=template&id=64b8d22a&scoped=true&"
var script = {}
import style0 from "./afterSale.vue?vue&type=style&index=0&id=64b8d22a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8d22a",
  null
  
)

export default component.exports